import { FC } from "react";

export const ExternalLinkIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H11C11.2833 3 11.521 3.09567 11.713 3.287C11.9043 3.479 12 3.71667 12 4C12 4.28333 11.9043 4.52067 11.713 4.712C11.521 4.904 11.2833 5 11 5H5V19H19V13C19 12.7167 19.096 12.479 19.288 12.287C19.4793 12.0957 19.7167 12 20 12C20.2833 12 20.5207 12.0957 20.712 12.287C20.904 12.479 21 12.7167 21 13V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM9 15C8.81667 14.8167 8.725 14.5833 8.725 14.3C8.725 14.0167 8.81667 13.7833 9 13.6L17.6 5H15C14.7167 5 14.4793 4.904 14.288 4.712C14.096 4.52067 14 4.28333 14 4C14 3.71667 14.096 3.479 14.288 3.287C14.4793 3.09567 14.7167 3 15 3H20C20.2833 3 20.5207 3.09567 20.712 3.287C20.904 3.479 21 3.71667 21 4V9C21 9.28333 20.904 9.52067 20.712 9.712C20.5207 9.904 20.2833 10 20 10C19.7167 10 19.4793 9.904 19.288 9.712C19.096 9.52067 19 9.28333 19 9V6.4L10.375 15.025C10.1917 15.2083 9.96667 15.3 9.7 15.3C9.43333 15.3 9.2 15.2 9 15Z"
      fill="currentColor"
    />
  </svg>
);
